import { Container, Row, Col } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import projImg1 from "../assets/img/Projects/Flipkart Clone.webp";
import projImg2 from "../assets/img/Projects/IRCTC.png";
import projImg3 from "../assets/img/Projects/SBi clone.webp";
import projImg4 from "../assets/img/Projects/Stock market clone.jpg";
import projImg5 from "../assets/img/Projects/Travel Clone.jpg";
import projImg6 from "../assets/img/Projects/Restro Clone.jpg";
import projImg7 from "../assets/img/Projects/CollabBoard.webp";
import projImg8 from "../assets/img/Projects/IntelliChat – Gen AI-Powered Live Support.png";
import projImg9 from "../assets/img/Projects/ShopSphere – Scalable E-Commerce Dashboard.jpeg";
import projImg10 from "../assets/img/Projects/WeatherPulse – Real-Time Weather & Disaster Alert Platform.jpeg";
import projImg11 from "../assets/img/Projects/Angular AI Dashboard – Predictive Insights Platform.jpeg";
import projImg12 from "../assets/img/Projects/SpaceX – Explore, Shop, and Learn Beyond Earth.jpeg";
import projImg13 from "../assets/img/Projects/Government College of Pharmacy Website.png";
import projImg14 from "../assets/img/Projects/Music Player Web App.jpeg";
import projImg15 from "../assets/img/Projects/Valentine Quiz – Interactive App.jpeg";
import colorSharp2 from "../assets/img/color-sharp2.png";
import "animate.css";
import TrackVisibility from "react-on-screen";
import HeadButton from "./HeadButton";
import React from "react";

export const Projects = () => {
  const projects = [
    {
      title: "Flipkart Clone",
      description:
        "Responsive e-commerce platform clone, built using React and modern tools.",
      imgUrl: projImg1,
      link: "https://ravisachincodinglife.github.io/FireBaseFlipkart-React/",
    },
    {
      title: "Irctc Clone",
      description:
        "IRCTC clone: React.js app for seamless train booking experience.",
      imgUrl: projImg2,
      link: "https://ravisachincodinglife.github.io/Irctc-React/",
    },
    {
      title: "SBI Clone",
      description:
        "An SBI clone made in HTML and JS replicates the State Bank of India’s website interface",
      imgUrl: projImg3,
      link: "https://ravisachincodinglife.github.io/SBI-Banking-Project/",
    },
    {
      title: "Small Case Stock Market Clone",
      description:
        "A Small Case stock market clone in HTML and JS provides a platform to track and manage stock investments",
      imgUrl: projImg4,
      link: "https://ravisachincodinglife.github.io/SmallCase/",
    },
    {
      title: "Tourist Website Clone",
      description:
        "A responsive tourist website clone showcasing destinations, booking features, and itineraries.",
      imgUrl: projImg5,
      link: "https://ravisachincodinglife.github.io/tourism-website/",
    },
    {
      title: "Cefrax Restaurant Clone",
      description:
        "Cefrax Restaurant Clone is a responsive, interactive website made using HTML and JavaScript, simulating a restaurant's menu and online ordering experience",
      imgUrl: projImg6,
      link: "https://ravisachincodinglife.github.io/Cefrax---Restaurant/",
    },
    {
      title: "CollabBoard – Digital Whiteboarding App",
      description:
        "Real-time multi-user collaboration app. Designed REST APIs with Node.js + Express and WebSocket-driven editing. Tech Stack: React, Redux, Node.js, REST APIs, WebSockets, MongoDB, AWS S3, Docker",
      imgUrl: projImg7,
      link: "https://collab-board-umber.vercel.app/",
    },
    {
      title: "IntelliChat – Gen AI-Powered Live Support",
      description:
        "Built GraphQL APIs for real-time chat messaging and AI integration. Reduced customer support time by 35%. Deployed with Docker + GitHub Actions CI/CD. Tech Stack: React, Node.js, GraphQL, WebSockets, Gemini API, AWS Elastic Beanstalk, Docker",
      imgUrl: projImg8,
      link: "https://drive.google.com/file/d/15_bCQSK4eSWHsAuJ538MhQjjwz5ZRsk_/view?usp=sharing",
    },
    {
      title: "ShopSphere – Scalable E-Commerce Dashboard",
      description:
        "Developed GraphQL endpoints for sales, inventory, and order management. Automated deployment with GitLab CI/CD pipelines. Tech Stack: Next.js, Node.js, GraphQL, AWS Lambda, DynamoDB, GitLab CI/CD",
      imgUrl: projImg9,
      link: "https://shop-sphere-zeta-one.vercel.app/auth/login",
    },
    {
      title: "WeatherPulse – Real-Time Weather & Disaster Alert Platform",
      description:
        "Designed REST APIs for live alert feeds using Node.js and AWS Lambda. Integrated Leaflet.js maps with WebSocket-driven real-time alerts. Tech Stack: React, Node.js, REST APIs, Leaflet.js, WebSockets, AWS Lambda, SNS",
      imgUrl: projImg10,
      link: "https://weather-pulse-teal.vercel.app/",
    },
    {
      title: "Angular AI Dashboard – Predictive Insights Platform",
      description:
        "Built Node.js APIs for predictive data insights, implemented role-based authentication with JWT and custom chart widgets. Tech Stack: Angular, Node.js, Chart.js, Gemini API",
      imgUrl: projImg11,
      link: "https://drive.google.com/file/d/1AOSOySnpasEwcaRfI_TNf8nFlUfSWWMB/view?usp=drive_link",
    },
    {
      title: "SpaceX – Explore, Shop, and Learn Beyond Earth",
      description:
        "Integrated SpaceX REST APIs for launches, astronauts, and Starlink data. Built JWT authentication APIs and Dockerized app. Tech Stack: React, Vite, Node.js, REST APIs, Zustand, MongoDB, Material UI, Docker",
      imgUrl: projImg12,
      link: "https://space-x-fawn.vercel.app/",
    },
    {
      title: "Government College of Pharmacy Website",
      description:
        "Developed the official website for Government College of Pharmacy, Amravati using HTML, CSS, JS, PHP, MySQL with responsive UI and dynamic content.",
      imgUrl: projImg13,
      link: "https://gcpharma.ac.in/Ravi",
    },
    {
      title: "Music Player Web App",
      description:
        "Interactive web music player built with modern web technologies.",
      imgUrl: projImg14,
      link: "https://musicplayer-six-beta.vercel.app/",
    },
    {
      title: "Valentine Quiz – Interactive App",
      description:
        "Interactive quiz web app built for fun learning and engagement.",
      imgUrl: projImg15,
      link: "https://velantainequiz.vercel.app/",
    },
  ];

  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible ? "animate__animated animate__fadeIn" : ""
                  }
                >
                  <HeadButton label="Projects" labelFontSize="1.5rem" />
                  <div
                    style={{
                      display: "flex",
                      gap: "10px",
                      alignItems: "center",
                      flexWrap: "wrap",
                      paddingTop: "40px",
                    }}
                  >
                    <Row>
                      {projects.map((project, index) => {
                        return <ProjectCard key={index} {...project} />;
                      })}
                    </Row>
                  </div>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2}></img>
    </section>
  );
};
